import mutations from "./mutations";
import * as actions from "./actions";

export default {
  actions,
  mutations,
  state: {
    values: {},
    primaryKeys: {}
  }
};
